import { useEffect, useRef } from 'react';
import { Heading, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css, cx, etiColors, mediaQueries, resetButtonStyle } from '@eti/styles';
import { X } from '@phosphor-icons/react';
import { constants } from '@eti/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const headerWrapperStyles = css`
  background-color: ${etiColors.white};
  display: flex;
  padding: 16px 8px;
  position: relative;
  width: 100%;

  @media ${mediaQueries.medium.up} {
    padding: 16px;
  }
`;
export const getCloseButtonStyles = css`
  align-items: center;
  display: flex;
  height: 100%;
  inset-block-start: 0;
  inset-inline-end: 0;
  outline: revert;
  padding: 0 8px;
  position: absolute;
  z-index: 1;

  & div {
    border-radius: 3px;
    display: flex;
    padding: 4px;
    position: relative;

    &::after {
      background-color: ${etiColors.white};
      border: 2px solid ${vars.colors.focusRing};
      border-radius: 6px;
      content: '';
      height: calc(100% + 4px);
      left: -2px;
      opacity: 0;
      position: absolute;
      top: -2px;
      transition: opacity 0.2s ease-in-out;
      width: calc(100% + 4px);
      z-index: -1;
    }
  }

  &:hover div {
    background-color: ${vars.colors.signal.information.tint};
  }

  &:focus-visible div {
    background-color: ${vars.colors.signal.information.tint};

    &::after {
      opacity: 1;
    }
  }
`;
const overlayContentStyles = css`
  flex: 0 1 100%;
  overflow: auto;
  padding: 16px 8px;

  & > *:not(:last-child) {
    margin-bottom: 16px;
  }

  @media ${mediaQueries.medium.up} {
    padding: 16px;
  }
`;
const overlayCardTitleStyles = css`
  font-size: 1.125rem;
  margin-bottom: 16px;
`;
const overlayFooterStyles = css`
  background-color: ${etiColors.white};
`;
export const OverlayHeader = _ref => {
  let {
    className,
    onClose,
    shouldApplyMouseflowMask,
    title,
    dialogCloseButtonAriaLabel
  } = _ref;
  const {
    t
  } = useTranslation();
  const titleRef = useRef(null);
  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/_jsxs("header", {
    className: cx(headerWrapperStyles, className),
    children: [/*#__PURE__*/_jsx(Heading, {
      className: shouldApplyMouseflowMask ? constants.MOUSE_FLOW_CLASS_NAMES : '',
      id: "modal-title",
      level: 2,
      ref: titleRef,
      tabIndex: -1,
      children: title
    }), onClose && /*#__PURE__*/_jsx("button", {
      "aria-label": dialogCloseButtonAriaLabel !== null && dialogCloseButtonAriaLabel !== void 0 ? dialogCloseButtonAriaLabel : t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
      className: cx(resetButtonStyle, getCloseButtonStyles),
      "data-testid": "overlay-close",
      onClick: onClose,
      type: "button",
      children: /*#__PURE__*/_jsx(X, {
        "aria-hidden": true,
        size: 24,
        weight: "light"
      })
    })]
  });
};
export const OverlayContent = _ref2 => {
  let {
    children,
    className,
    innerRef,
    ...props
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: cx(overlayContentStyles, className),
    ref: innerRef,
    ...props,
    children: children
  });
};
export const OverlayCardTitle = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/_jsx("h3", {
    className: overlayCardTitleStyles,
    children: children
  });
};
export const OverlayFooter = _ref4 => {
  let {
    children,
    className,
    innerRef,
    ...props
  } = _ref4;
  return /*#__PURE__*/_jsx("footer", {
    className: cx(overlayFooterStyles, className),
    ref: innerRef,
    ...props,
    children: children
  });
};
//# sourceMappingURL=OverlayComponents.js.map